const state = {
  refreshStockUpList: false
}

const mutations = {
  SET_REFRESH_STOCK_UP_LIST_STATUS: (state, data) => {
    state.refreshStockUpList = data
  }
}

const actions = {
  refreshStockUpList({ commit }, data) {
    commit('SET_REFRESH_STOCK_UP_LIST_STATUS', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
